import React from 'react';
import cls from '@utils/css-select';
import { RouteComponentProps } from 'react-router';
import styles from './styles.scss';
import Section from 'components/section';
import Header from 'containers/landing/header';
import TraitBox from './component/trait-box';
import StepBox from './component/step-box';
import AddressBox from './component/address-box';
import FromTable from './component/form-table';
import AppraisalBox from './component/appraisal-box';
import GradeBlock from './component/grade-block';
import TechBlock from './component/tech-block';
import Footer from './component/footer';
const cx = cls(styles);

/**
 * 6过落地页
 */
export default function LandingHome(props: RouteComponentProps) {
	const withStep = props.match.path === '/uk/apply-tutor/step'; // 二跳页  分步填写表单
	const withTint = props.match.path === '/uk/apply-tutor/tint'; // 动效页 滚动播报+倒计时
	return (
		<div className={cx('landing-container')}>
			<Header showRight={!withStep && !withTint} />
			<FromTable step={withStep} tint={withTint} rollingText={withTint} />
			<AppraisalBox />
			<div className={cx('tech-eg')}>
				<Section>
					<h3 className={cx('block-title')}>Online 1-on-1 class, anywhere and anytime!</h3>
					<div className={cx('eg-list', 'scroll-view')}>
						<div className={cx('eg-item')}>
							<img loading="lazy" src="https://web-data.zmlearn.com/image/eQ4UjP5RkcpZsJJgerBfxK/11%402x.png" alt="air-class" />
							<div className={cx('txt')}>
								<h4>More convenient</h4>
								<p>Only you need is your PC/iPad</p>
							</div>
						</div>
						<div className={cx('eg-item')}>
							<img loading="lazy" src="https://web-data.zmlearn.com/image/qsRKMCezeBZbD4JmNp8QxG/12%402x.png" alt="air-class" />
							<div className={cx('txt')}>
								<h4>More Efficient</h4>
								<p>Real-time class interaction and ready for Q&A during the class</p>
							</div>
						</div>
						<div className={cx('eg-item')}>
							<img loading="lazy" src="https://web-data.zmlearn.com/image/cqG7tzfUQZ4YqhoXCykxAB/13%402x.png" alt="air-class" />
							<div className={cx('txt')}>
								<h4>More intelligent</h4>
								<p>Automatic recording and always available for review</p>
							</div>
						</div>
					</div>
				</Section>
			</div>
			<TechBlock />
			<GradeBlock />
			<StepBox />
			<TraitBox />
			<AddressBox />
			<Footer tint={withTint} />
		</div>
	);
}
